<template>
	<div class="form form--search">
		<Field
			name="search"
			type="search"
			:placeholder="placeholder"
			:model-value="modelValue"
			@update:model-value="handleInput"
		/>

		<button type="submit" aria-label="Submit Search">
			<Icon name="search" :color="cssVariables.primary" />
		</button>
	</div>
</template>

<script>
/**
 * Internal Dependencies
 */
import { debounce } from '@/utils/use-debounce'
import variables from '@/utils/scss-variables'
import Icon from '@/components/icon/icon';
import Field from '@/components/field/field';

export default {
	/**
	 * Name
	 */
	name: 'Search',

	/**
	 * Components
	 */
	components: {
		Icon,
		Field
	},
	
	/**
	 * Emits
	 */
	emits: ['update:modelValue'],

	/**
	 * Props
	 */
	props: {
		modelValue: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		}
	},

	/**
	 * Computed
	 */
	computed: {
		cssVariables() {
			return variables
		},
	},

	methods: {
		handleInput: debounce(function (value) {
			this.$emit('update:modelValue', value);	
		}, 500) 
	},
};
</script>
